import { Grid, TextField } from '@mui/material'
import get from 'lodash.get'
import { useFormikContext } from 'formik'
import AddressAutocomplete from 'components/common/AddressAutocomplete'

function AddressInput({
  addressKeys,
  disabled,
  labels = {},
  ignoreCountry = false,
}) {
  const { values, errors, handleChange, handleBlur } = useFormikContext()

  const handleUpdateChange = (e) => {
    handleChange(e)
  }

  return (
    <>
      <Grid item xs={12}>
        <AddressAutocomplete
          ignoreCountry={ignoreCountry}
          addressKeys={addressKeys}
          textFieldProps={{
            size: 'small',
            placeholder: labels.address || 'Address',
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          size="small"
          label={labels.city || 'City'}
          variant="outlined"
          value={get(values, addressKeys.city)}
          onChange={handleUpdateChange}
          name={addressKeys.city}
          error={Boolean(get(errors, addressKeys.city))}
          helperText={get(errors, addressKeys.city)}
          disabled={disabled}
          onBlur={handleBlur}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          size="small"
          label={labels.state || 'State'}
          variant="outlined"
          value={get(values, addressKeys.state)}
          onChange={handleUpdateChange}
          name={addressKeys.state}
          error={Boolean(get(errors, addressKeys.state))}
          helperText={get(errors, addressKeys.state)}
          disabled={disabled}
          onBlur={handleBlur}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          size="small"
          label={labels.zip || 'Zip'}
          variant="outlined"
          value={get(values, addressKeys.zip)}
          onChange={handleUpdateChange}
          name={addressKeys.zip}
          error={Boolean(get(errors, addressKeys.zip))}
          helperText={get(errors, addressKeys.zip)}
          disabled={disabled}
          onBlur={handleBlur}
        />
      </Grid>
    </>
  )
}

export default AddressInput
